import StringColumn from './StringColumn';

export default class AutoCompleteStringColumn extends StringColumn {

    createFilter() {
        
        const dataUrl = this.api.ajax.url();
        const fieldName = this.filterByProp;

        return `<div class="input-group">
                    <select class="form-control table-filter autocomplete-filter"
                            data-odata-url="${dataUrl}"
                            data-autocomplete="${fieldName}"
                            data-placeholder="${this.api.i18n('Select2Placeholder', 'Choose...')}"></select>
                </div>`;

    }
    
    setFilterValue(value) {

		const inputs = this.column.filter().find('.table-filter');
		const values = value.split('~', 2);

		if(inputs.length > 0) {

            const $input = $(inputs.get(0));
            const value = values[0] || '';

            if ($input.data('select2')){
                if ($input.find(`option[value='${value}']`).length == 0) {

                    $input.append(`<option value="${value}">${value}</option>`);
                }
            }
            $input.val(value).trigger("change");
    	}
		if(inputs.length > 1) {
			$(inputs.get(1)).val(values[1] || '');
		}
    }
    
    setFilterFocus() {

		setTimeout(() => {
			this.column.filter().find('.table-filter').select2("open");
		}, 100);

    }
    
    showFilterButton() {

        return false;
	}
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/renderers/AutoCompleteStringColumn.js